<template>
    <div class="custom-menu" v-scrollbar>
        <el-menu
            :style="{width:isCollapse?'64px':'200px'}"
            :collapse="isCollapse"
            :default-active="currentPath"
            :default-openeds="defaultOpened"
            :unique-opened="true"
            :router="true"
            @open="openHandle"
            @close="closeHandle"
            @select="selectHandle"
            background-color="#0d4074"
            text-color="#eee"
            active-text-color="#ffee66"
        >
            <template v-for="item in menuList">
                <template v-if="item.isMenu">
                    <el-submenu v-if="item.children" :key="item.name" :index="item.path">
                        <template slot="title">
                            <i class="custom-menu-icon" :class="item.icon" v-if="item.icon"></i>
                            <span class="title">{{item.title}}</span>
                        </template>
                        <el-menu-item v-if="v.isMenu" v-for="(v,i) in item.children" :key="item.name +'-' + i" :index="item.path+'/'+v.path">
                            {{v.title}}
                            <span v-if="v.name === 'auditComic' && userInfo.auditComic" class="custom-audit-notice">{{ userInfo.auditComic }}</span>
                            <span v-if="v.name === 'auditAnComic' && userInfo.auditAnComic" class="custom-audit-notice">{{ userInfo.auditAnComic }}</span>
                            <span v-if="v.name === 'auditRelatedVideo' && userInfo.auditRelative" class="custom-audit-notice">{{ userInfo.auditRelative }}</span>
                        </el-menu-item>
                    </el-submenu>
                    <el-menu-item v-else :key="item.name" :index="item.path">
                        <i class="custom-menu-icon" :class="item.icon" v-if="item.icon"></i>
                        <span class="title">{{item.title}}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import io from 'socket.io-client';

export default {
    props: {
        isCollapse: Boolean
    },
    data() {
        return {
            socket: null
        };
    },
    computed: {
        ...mapState('app', {
            menuList: state => state.menuList,
            userInfo: state => state.userInfo
        }),
        defaultOpened() {
            const matched = this.$route.matched;
            const len = matched.length;
            if (len === 2) return [matched[1].path];
            else if (len >= 3) return [matched[1].path, matched[2].path];
        },
        currentPath(menu) {
            const matched = this.$route.matched;
            const len = matched.length;
            if (len === 2) return matched[1].path;
            else if (len >= 3) {
                // 特殊处理
                const path2 = matched[2].path;
                if (['/main/adminCenter/auditComicInfo'].includes(path2)) return '/main/adminCenter/auditComic';
                if (['/main/adminCenter/auditAnComicInfo'].includes(path2)) return '/main/adminCenter/auditAnComic';
                if (['/main/adminCenter/auditRelatedVideoInfo'].includes(path2)) return '/main/adminCenter/auditRelatedVideo';
                if (['/main/comic/editComic', '/main/comic/editComicChapter'].includes(path2)) return '/main/comic/myComic';
                return path2;
            }
        }
    },
    watch: {
        userInfo(val) { // 有用户信息的情况下，建立socket连接
            if (val.id && !this.socket) {
                this.initSockect();
            }
        }
    },
    mounted() {
        this.initAuditData();
    },
    methods: {
        initAuditData() {
            this.$api('auditPendingInfo').then((res) => {
                this.setAuditInfo(res.data);
            });
        },
        initSockect() {
            this.socket = io(this.$config.socketUrl, {
                query: {
                    uid: this.userInfo.id,
                    level: this.userInfo.level
                }
            });
            this.socket.on('audit_pending', data => {
                this.setAuditInfo(data);
            });
            this.socket.on('connect', () => {
                console.log('client connect server');
            });
            this.socket.on('disconnect', function() {
                console.log('client disconnect');
            });
        },
        setAuditInfo(data) {
            const { commit } = this.$store;
            const auditData = {
                auditComic: this.setNum(data.comic),
                auditAnComic: this.setNum(data.animation),
                auditRelative: this.setNum(data.animation_correlation)
            };
            commit('app/setUserInfoCustom', { ...this.userInfo, ...auditData });
        },
        setNum(val) {
            return val > 99 ? 99 : val;
        },
        // menu展开
        openHandle() {
        },
        // menu关闭
        closeHandle() {
        },
        // menu选中
        selectHandle() {
        }
    }
};
</script>
<style lang="scss">
    .custom-menu{
        height: calc(100% - 64px);
        overflow: hidden;
        position: relative;
        transition: width 0.5s ease;
        .el-menu{
            border-right: none;
            transition: width 0.5s ease;
            .el-submenu__title{
                display: flex;
                flex-flow: row nowrap;
                align-items: center;
                span.title{
                    font-size: 14px;
                    margin-left: 5px;
                }
            }
        }
        &-icon{
            font-size: 18px;
        }

        .custom-audit-notice{
            display: inline-block;
            text-align: center;
            width: 18px;
            height: 18px;
            line-height: 18px;
            border-radius: 100%;
            background: #ff0000;
            margin-left: 0;
        }
    }
</style>
